/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nimble_Cozy_Firefox_GreetInputs */

const fr_nimble_cozy_firefox_greet = /** @type {(inputs: Nimble_Cozy_Firefox_GreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine précédente`)
};

/**

* @param {Nimble_Cozy_Firefox_GreetInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const nimble_cozy_firefox_greet = /** @type {((inputs?: Nimble_Cozy_Firefox_GreetInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nimble_Cozy_Firefox_GreetInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_nimble_cozy_firefox_greet(inputs)
});